export interface CheckoutConfig {
  rules: RulesTy[];
}

export type RulesTy = {
  step: number;
  name: string;
  formTitle?: string;
  formDescription?: string;
};

const RULES: RulesTy[] = [
  {
    step: 1,
    name: 'Shipping',
    formTitle: 'Shipping Address',
    formDescription: 'All fields required unless otherwise indicated',
  },
  {
    step: 2,
    name: 'Billing',
    formTitle: 'billing title',
    formDescription: 'billing description',
  },
  {
    step: 3,
    name: 'Payment',
    formTitle: 'payment title',
    formDescription: 'payment description',
  },
  {
    step: 4,
    name: 'Review',
    formTitle: 'Checkout Review',
    formDescription: 'Please review all the details are correct.',
  },
];

export default function getCheckoutConfig(): CheckoutConfig {
   return { rules:RULES };
}
